/**
 * Generated by orval v6.31.0 🍺
 * Do not edit manually.
 * Bondsmith Savings Exchange Operation Portal APIs
 * OpenAPI spec version: 0.1
 */

export type ChangeRequestType =
  typeof ChangeRequestType[keyof typeof ChangeRequestType];

// eslint-disable-next-line @typescript-eslint/no-redeclare
export const ChangeRequestType = {
  CREATE: 'CREATE',
  UPDATE: 'UPDATE',
  RETIRE: 'RETIRE',
  SOFT_CLOSURE: 'SOFT_CLOSURE',
} as const;
